import { useState } from 'react';
import { Icon } from '@iconify/react';

// material
import { MenuItem, Collapse, ListItemIcon, ListItemText } from '@mui/material';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator
} from '@mui/lab';

import PropTypes from 'prop-types';

import { useTranslation } from '../../common/LocalizationProvider';

// ----------------------------------------------------------------------

FlightListTimeLineAlert.propTypes = {
  reportTrip: PropTypes.object.isRequired
};

export default function FlightListTimeLineAlert({ reportTrip }) {
  const t = useTranslation();

  const [isOpen, setIsOpen] = useState(true);
  const handleIsOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <MenuItem sx={{ color: 'text.secondary' }} onClick={handleIsOpen}>
        <ListItemIcon>
          {!isOpen ? (
            <Icon icon="ant-design:plus-circle-outlined" width={24} height={24} />
          ) : (
            <Icon icon="ant-design:minus-circle-outlined" width={24} height={24} />
          )}
        </ListItemIcon>
        <ListItemText
          primary={t('FL_Menu_Alert_List')}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </MenuItem>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Timeline sx={{ marginLeft: -17 }}>
          <TimelineItem sx={{ display: reportTrip.alertGeofence ? true : 'none' }}>
            <TimelineSeparator>
              <TimelineDot color="secondary" />
              {reportTrip.gAlert || reportTrip.alertSpeed ? <TimelineConnector /> : null}
            </TimelineSeparator>
            <TimelineContent variant="body1">{reportTrip.alertGeofence || 0} ZP</TimelineContent>
          </TimelineItem>

          <TimelineItem sx={{ display: reportTrip.gAlert ? true : 'none' }}>
            <TimelineSeparator>
              <TimelineDot color="secondary" />
              {reportTrip.alertSpeed ? <TimelineConnector /> : null}
            </TimelineSeparator>
            <TimelineContent variant="body1">{`${reportTrip.gAlert || 0} ${
              reportTrip.gAlert > 1 ? t('FL_Menu_Alert_List_G_S') : t('FL_Menu_Alert_List_G')
            }`}</TimelineContent>
          </TimelineItem>

          <TimelineItem sx={{ display: reportTrip.alertSpeed ? true : 'none' }}>
            <TimelineSeparator>
              <TimelineDot color="secondary" />
            </TimelineSeparator>
            <TimelineContent variant="body1">{`${reportTrip.alertSpeed || 0} ${
              reportTrip.alertSpeed > 1
                ? t('FL_Menu_Alert_List_Speed_S')
                : t('FL_Menu_Alert_List_Speed')
            }`}</TimelineContent>
          </TimelineItem>
        </Timeline>
      </Collapse>
    </>
  );
}
